// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"1c7e3a19","77":"d96744f8","111":"065ce3b7","247":"0e4bd212","306":"236ccfc7","440":"218f440e","909":"6adf3a54"}[chunkId] + ".chunk.css";
};